export default {
  install: (Vue, asset) => {
    Vue.prototype.$asset = path => `${asset}/${path.trim('/')}`;
  },
};
